// extracted by mini-css-extract-plugin
export default {"cls1":"ProfilePdfPackCard-cls1_BW9","cls2":"ProfilePdfPackCard-cls2__NK ProfilePdfPackCard-cls1_BW9"};